import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "¿Cuánto tarda en estar lista mi web?",
    a: "Depende del pack: Básico entre 3-5 días, Estándar 5-7 días, Premium 7-10 días desde que empezamos.",
  },
  {
    q: "¿Qué necesitáis de mí para empezar?",
    a: "Solo la información de tu negocio: nombre, servicios, fotos si tienes, y una idea de qué estilo te gustaría. Del resto nos encargamos nosotros.",
  },
  {
    q: "¿El dominio y el hosting están incluidos?",
    a: "Sí, en el primer año. A partir del segundo año, la renovación anual va por tu cuenta (te avisamos cuando toque).",
  },
  {
    q: "¿Puedo cambiar cosas después de la entrega?",
    a: "Sí. En el Pack Premium incluimos un mes de soporte y ajustes gratis. En los demás packs, los cambios se cotizan aparte.",
  },
  {
    q: "¿Qué pasa si no me gusta el resultado?",
    a: "Trabajamos juntos con revisiones antes de dar la web por terminada, así que no llegamos a ese punto. Si algo no encaja, lo ajustamos.",
  },
  {
    q: "¿Puedo pagar en varios plazos?",
    a: "Sí. Trabajamos con 50% al inicio y 50% al entregar la web.",
  },
];

const Item = ({ faq, index, open, onToggle }) => (
  <div className="border-b border-white/10" data-testid={`faq-item-${index}`}>
    <button
      onClick={onToggle}
      data-testid={`faq-toggle-${index}`}
      aria-expanded={open}
      className="flex w-full items-center justify-between gap-6 py-6 text-left"
    >
      <span className="font-head text-lg font-medium text-white sm:text-xl">{faq.q}</span>
      <motion.span
        animate={{ rotate: open ? 45 : 0 }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-white/15 text-[#00E5FF]"
      >
        <Plus className="h-4 w-4" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          key="content"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p className="pb-6 pr-14 text-base leading-relaxed text-zinc-400">{faq.a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative mx-auto max-w-4xl px-5 py-24 md:px-10 md:py-32">
      <Reveal>
        <span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">06 — FAQ</span>
        <h2 className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
          Preguntas <span className="font-black">frecuentes</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-12">
        {faqs.map((faq, i) => (
          <Item
            key={faq.q}
            faq={faq}
            index={i}
            open={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
          />
        ))}
      </Reveal>
    </section>
  );
};
